import React, { useState, useEffect, useContext } from 'react'
import { navigate } from 'gatsby'
import SVG from 'react-inlinesvg'

import { NavContext } from './nav'
import trackLink from '../../../utils/helpers/tracking/track-link'
import external from '../../../assets/icons/external-link.svg'

const LinkCustom = props => {
  const [linkClasses, setLinkClasses] = useState(props.className)
  const { subOpen, activeSub, mobileOpen } = useContext(NavContext)
  const [isSubOpen, setIsSubOpen] = subOpen
  const [isActiveSub, setActiveSub] = activeSub
  const [isMobileOpen, setIsMobileOpen] = mobileOpen
  const isInternalLink = props.to.startsWith('/')
  const isTracked = props.trackClick && props.trackClick?.eventAction ? true : false

  // Active state
  useEffect(() => {
    const activeClassName = `${props.className} current`
    const linkValue = props.to
    const currentLocation = location.pathname

    const isHomePage = props.to === '/' || props.to === '/fr/' || props.to === '/de/' || props.to === '/ja/' || props.to === '/pt-br/' || props.to === '/pt/' || props.to === '/ko/' || props.to === '/zh-hans/' || props.to === '/zh-hant/' || props.to === '/zh-s/' || props.to === '/zh-t/' || props.to === '/it/' || props.to === '/es/' ? true : false

    if (currentLocation.startsWith(linkValue) && !isHomePage) {
      setLinkClasses(activeClassName)
    } else if (currentLocation === props.to && isHomePage) {
      setLinkClasses(activeClassName)
    } else {
      setLinkClasses(props.className)
    }
  })

  // Gatsby Navigate for internal links only
  const handleClick = event => {
    if (isInternalLink) {
      event.preventDefault()
      if (isSubOpen !== false) {
        setIsSubOpen(false)
        setActiveSub(null)
      }

      // Close mobile menu if direct link
      if (props.href !== '') {
        setIsMobileOpen(false)
      }

      // Track internal link click in dataLayer
      if (isTracked) {
        trackLink(props.trackClick)
      }
      navigate(props.to)
    } else {
      // Track external link click in dataLayer
      if (isTracked) {
        trackLink(props.trackClick)
      }
    }
  }

  // Anchor Links
  if (props.anchor && props.anchor !== '') {
    return (
      <AnchorLink
        anchor={props.anchor}
        to={props.anchor && props.anchor !== '' ? props.anchor : null}
        role={props.role}
        ariaLabel={`Scroll to ${props.title ? props.title : props.anchor}`}
        className={props.className ? props.className : ''}
        trackClick={isTracked ? props.trackClick : false}
      >
        {props.children}
      </AnchorLink>
    )
  }

  // Empty Links
  if (props.to === '') {
    return <span>{props.children}</span>
  }

  // Internal & External Links
  return (
    <a
      href={props.to}
      role={props.role}
      target={props.target ? props.target : !isInternalLink ? '_blank' : '_self'}
      rel={(props.target === '_blank' && !props.anchor) || !isInternalLink ? 'noopener noreferrer' : undefined}
      tabIndex={props.tabIndex}
      onClick={handleClick}
      className={linkClasses}
      aria-expanded={props.ariaExpanded}
    >
      {props.children}
      {!isInternalLink && (
        <ExternalIndicator
          disableIndicator={props.disableIndicator ? props.disableIndicator : false}
        />
      )}
    </a>
  )
}

// External links indicator icon
const ExternalIndicator = props => {
  if (props.disableIndicator) {
    return ''
  }
  return (
    <SVG
      onError={error => console.log(error.message)}
      cacheRequests={true}
      preProcessor={code =>
        code.replace(/fill=".*?"/g, 'fill="currentColor"')
      }
      src={external}
      className="externallink-indicator ml-4 inline-block w-5 text-grayMedium"
    />
  )
}

// Anchor Links
const AnchorLink = props => {
  const [anchorTarget, setAnchorTarget] = useState()

  useEffect(() => {
    setAnchorTarget(document.getElementById(props.anchor))
  }, [props.anchor])


  const handleClick = event => {
    event.preventDefault()
    if (props.onClick) {
      props.onClick
    }

    // Track link click in dataLayer
    if (props.trackClick) {
      trackLink(props.trackClick)
    }

    anchorTarget.scrollIntoView({ behavior: 'smooth', block: 'start' })
  }

  return (
    <a
      onClick={handleClick}
      role={props.role}
      ariaLabel={`Scroll to ${props.title}`}
      className={props.className}
    >
      {props.children}
    </a>
  )
}

export default LinkCustom
